import {environment} from "../../../environments/environment";

export class HttpService {
    static SERVICE_PATH = environment.apiUrl;
}